import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    key: _ctx.key,
    class: _normalizeClass(_ctx.pagerItem.class),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.pagerItem.href))),
    title: `${_ctx.pagerItem.text}`,
    type: "button"
  }, [
    (_ctx.pagerItem.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: _ctx.pagerItem.icon,
          class: "icon"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.pagerItem.text), 1))
  ], 10, _hoisted_1))
}